import React, { Component } from 'react';

import { postJson } from '../helpers/RequestsHelper'
import { validateEmail } from '../helpers/utils';

class ContactFormTools extends Component {

    state = {
        canContact: true,
        completed: false,
        email: "",
        name: "",
        id: 1,
        localId: "",
        timer: 10,
    }

    constructor(props) {
        super()
        this.onSubmit = this.onSubmit.bind(this)
        this.onChange = this.onChange.bind(this)
        this.scrollToBottom = this.scrollToBottom.bind(this)
        this.tickTock = this.tickTock.bind(this)
    }

    scrollToTop = () => {
        let root = document.getElementById('root')
        root.scrollIntoView({ behavior: 'smooth' })
    }

    scrollToBottom = () => {
        this.elBottom.scrollIntoView({ behavior: 'smooth' });
    }

    onSubmit = async (e) => {
        let body = this.state

        const cognitoUser = window.userPool.getCurrentUser()

        if (cognitoUser) {
            //This is done for pages that do not require authentication
            body.userId = cognitoUser.username
        }

        await postJson(process.env.REACT_APP_SERVER_BASE_URL + window.location.pathname, body)

        this.setState({ completed: true })

        this.tickTock()

        setTimeout(() => {
            this.scrollToTop()
        }, 200)
    }

    async tickTock() {
        if(this.state.timer === 0) {
            return
        } else {
            this.setState({timer: this.state.timer - 1})
            await setTimeout(this.tickTock, 1000)
        }
    }

    onChange = (state) => {
        this.setState(state)
    }

    render() {
        if(!this.state.completed) {
            return (
                <div>
                    <div className="custom-control custom-switch" style={{marginBottom: '8px'}}>
                        <input type="checkbox" className="custom-control-input" id="switch" checked={this.state.canContact} onChange={(e) => this.onChange({ canContact: e.target.checked })} />
                        <label className="custom-control-label" htmlFor="switch">Yes, please, send me more of these tools!</label>
                    </div>
        
                    {this.state.canContact ?
                        <div ref={el => { this.elBottom = el; }}>
                            Email
                            {validateEmail(this.state.email) ? "" : <small style={{marginLeft: '4px'}} id="errorMessage" className="text-danger">Please enter a valid email address</small>}
                            <input className="form-control w-400"
                                type="email"
                                name="email"
                                autoComplete="email"
                                id="email"
                                onFocus={(e) => this.scrollToBottom()}
                                onChange={(e) => this.onChange({ email: e.target.value })} />
                            Name
                            <input className="form-control w-400"
                                type="text"
                                name="name"
                                autoComplete="name"
                                id="name"
                                onChange={(e) => this.onChange({ name: e.target.value })} />
                            <br />
                            <button className="submit-btn w-400" onClick={this.onSubmit} disabled={this.state.email.trim() == "" || !validateEmail(this.state.email)}>Submit</button>
                        </div>
                    : null}
        
                </div>
            )
        } else {
            return this.state.timer === 0? null : (
                <div>
                    <span className="text-success"><b>Thanks for subscribing!</b></span>
                </div>
            )
        }
    }
    
}

export default ContactFormTools